import { ReactNode, useMemo } from 'react';
import dynamic from 'next/dynamic';

import { useAuthContext } from '@picsart/growth-rc/AuthContext';

const DriveProvider = dynamic(() => import('@picsart/cloud-storage/DriveContext'));

function DriveWrapper({ children }: { children: ReactNode | ReactNode[] }) {
  const { tokenData, user } = useAuthContext();
  const initialAuthState = useMemo(() => ({ user, tokenData }), [user, tokenData]);

  return <DriveProvider initialAuthState={initialAuthState}>{children}</DriveProvider>;
}

export default DriveWrapper;
